import { SubscriptionTypeEnum } from '@/bundles/Subscriptions/enums/subscriptionTypeEnum';
import { ISubscriptionsStore } from '@/store/modules/subscriptions/index';

const hasBeePluginSubscription = (state: ISubscriptionsStore) => {
  return state.subscriptions.some((subscription) => subscription.type === SubscriptionTypeEnum.bee_plugin);
}

export default { hasBeePluginSubscription };
